import { Store } from "@tanstack/store";

const STORAGE_KEY = 'esaj-theme-settings'

function loadInitialState(): {theme: string, title: string, size: string, chargeLayout: 'new' | 'old'} {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored) {
        const parsed = JSON.parse(stored)
        if (parsed.theme === 'dark') {
            document.body.classList.add('dark')
        }
        if (parsed.size) {
          document.documentElement.classList.add(parsed.size)
        }
        if (!parsed.chargeLayout) {
          parsed.chargeLayout = 'new'
        }
        return parsed
    }
    } catch {}
    return {
        theme: 'light',
        title: 'خانه',
        size: 'text-sm',
        chargeLayout: 'new'
    }
   }

export const themeStore = new Store(loadInitialState())

themeStore.subscribe((state) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state.currentVal))
    } catch {}
   })